import { defineStyleConfig } from '@chakra-ui/react';

export const ButtonStyle = defineStyleConfig({
  sizes: {
    sm: {
      h: '40px',
    },
    md: {
      fontSize: 'md',
      h: '46px',
      borderRadius: '8px',
    },
    lg: {
      fontSize: 'md',
      fontWeight: 'semibold',
      h: '62px',
      borderRadius: '8px',
    },
  },
});
